<template>
  <div>
    <el-table :data="rowData" v-if="columns.length > 0">
      <!-- 动态生成表格列 -->
      <el-table-column v-for="column in columns" :key="column.prop" :prop="column.prop" :label="column.label">
      </el-table-column>
    </el-table>
    <div v-else>
      表格数据为空
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  props: {
    columns: {
      type: Array,
      required: true,
    },
    rows: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const rowData = ref(props.rows);

    return {
      rowData,
    };
  },
};
</script>

<style>
/* 样式可以根据需要进行调整 */
</style>
